<template lang="pug">
footer
  div
    .row.justify-content-center.align-items-center.contact_info
      .d-md-flex.justify-content-center.col-xl-auto.col-lg-12
        p TEL: (02)8772-7777
        p Address: 8-13F, No.130, Sec.3 ,Nanjing E. Road, Taipei 104, Taiwan, R.O.C.
    .row.justify-content-center.align-items-start.align-items-md-center.copy_right
      .d-flex.justify-content-between.align-items-md-center.align-items-start.col-xl-auto.col-lg-12
        .copy_right_img
          img(src="@/assets/img/media/footer-corp.png" alt="東京海上集團")
        .copy_right_text
          div
            img(src="@/assets/img/media/footer-slogan.png" alt="To Be a Good Company")
          div  
            p Copyright © Tokio Marine Newa Insurance Co., Ltd.
            p  All Rights Reserved.
</template>

<script>
export default {
  name: "CustomFooter",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
footer {
  background-color: #005bac;

  .row {
    // height: 60px;
    align-items: center;
    justify-content: center;
  }

  p {
    font-size: 0.875rem;
    letter-spacing: 0.5px;
    margin: 0;
    cursor: initial;
  }

  .contact_info {
    width: 100%;
    margin: 0 auto;
    > div {
      padding: 7px 0;
    }
    p {
      font-weight: normal;
      color: $color_white;
      &:nth-child(1)::after {
        content: "｜";
        display: inline;
      }
    }
  }

  .copy_right {
    background-image: linear-gradient(to right, #00b3fe, #039);
    border-top: 1px solid $color_white;
    height: 100%;
    > div {
      width: 100%;
      height: inherit;
      background-image: url("~@/assets/img/media/footer-bg.png");
      background-repeat: no-repeat;
      background-position: right bottom;
    }
    &_img {
      padding-left: 35px;
      img {
        width: 164px;
      }
    }
    &_text {
      padding: 20px 118px 20px 0;
      text-align: right;
      p {
        color: $color_white;
        font-weight: 600;
        font-size: 12px;
      }
    }
  }
}
@media (max-width: 767px) {
  footer {
    .contact_info {
      height: 100%;
      > div {
        width: auto;
        padding: 10px 0px;
      }
      p {
        display: block;
        font-size: 1rem;
        &:nth-child(1)::after {
          content: " ";
          display: inline;
        }
      }
    }
    .copy_right {
      > div {
        background-size: 72px;
      }
      &_img {
        padding: 7px 0px 20px;
        img {
          width: 104px;
        }
      }
      &_text {
        padding: 7px 0px 20px;
        img {
          width: 140px;
        }
        p {
          font-size: 10px;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  footer {
    .contact_info {
      p {
        font-size: 3.2vw;
      }
    }
  }
}
</style>
